import React from 'react'
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'

import { ExportToXLSBtn, FilterBox } from '../../../../ui'
import { EEPP_TABLE_COLUMNS, EEPP_TABLE_FILTERS } from '../../constants/eepp-table.constants'
import { eeppDataPreparation } from '../../logics'
import { useEEPPCalls } from '../../hooks'

export const EEPPHeader = () => {
  const intl = useIntl()
  const combos = useSelector((state) => state.combos)
  const { getEEPP } = useEEPPCalls()
  const role = useSelector((state) => state.global.role)
  const eeppLoader = useSelector((state) => state.loader.eepp)

  const selection = eeppLoader?.selection
  const search = eeppLoader?.config?.params

  const filters = EEPP_TABLE_FILTERS

  const buttons = (
    <ExportToXLSBtn
      selectedRows={selection}
      columnsExport={EEPP_TABLE_COLUMNS}
      getAllData={() => {
        return new Promise((resolve, reject) => {
          getEEPP({ params: { ...search, _num_x_pagina: 0 } })
            .then(({ data }) => {
              return resolve(eeppDataPreparation(data.empresas, { intl }))
            })
            .catch((err) => {
              return reject(err)
            })
        })
      }}
      titleRoot="eepp_"
      headerNamespace="eepp"
    />
  )

  const data = filters.map((item, i) => {
    if (item.comboId) {
      item.values = combos[item.comboId] && combos[item.comboId].data
    }
    return {
      ...item,
      label: intl.formatMessage({
        id: 'pages.eepp.filters.' + item.name + '.title',
      }),
    }
  })

  return (
    <>
      <FilterBox filters={data}>
        {['e_commerce', 'call_center'].includes(role) ? buttons : null}
      </FilterBox>    </>
  )
}
